import { NgModule } from '@angular/core';

import { CopyToClipboard } from '@shared/modules/copy-to-clipboard/copy-to-clipboard.directive';

@NgModule({
  declarations: [CopyToClipboard],
  exports: [CopyToClipboard],
})
export class CopyToClipboardModule {}
